import { FC } from 'react';

import { formatCurrencyDecimals, formatNumber } from 'utils/formats';
import { useBeneficiarySellModal } from '../context/BeneficiarySellModalContext';
import { getDataFromBeneficiary } from '../utils/getDataFromBeneficiary';
import getPriceByPlan from '../utils/getPriceByPlan';

type TableRowProps = {
  index: number;
  beneficiaryData: any;
};

const PlanTableRow: FC<TableRowProps> = ({ index, beneficiaryData }) => {
  const { data } = useBeneficiarySellModal();

  const {
    planName,
    cliff,
    vestingPeriod,
    sharePrice,
    sharesCountFuture,
    beneficiaryUnits,
    soldUnits,
  } = getDataFromBeneficiary(beneficiaryData);

  const resultPrice = getPriceByPlan(
    beneficiaryData,
    data.unitsPrice,
    data.includeBeneficiaryNotVestedUnits
  );

  return (
    <>
      <td key={`number-${index}`} className="text-center">
        {index + 1}
      </td>
      <td key={`name-${index}`} className="text-left w-min-150px">
        {planName}
      </td>
      <td key={`cliff-${index}`} className="text-center">
        {cliff}
      </td>
      <td key={`vesting-period-${index}`} className="text-center">
        {vestingPeriod}
      </td>
      <td key={`future-shares-${index}`} className="text-right">
        {formatNumber(sharesCountFuture)}
      </td>
      <td key={`beneficiary-units-${index}`} className="text-right">
        {formatNumber(beneficiaryUnits)}
      </td>
      <td key={`sold-units-${index}`} className="text-right">
        {formatNumber(soldUnits)}
      </td>
      <td key={`share-price-${index}`} className="text-right">
        {formatCurrencyDecimals(sharePrice)}
      </td>
      <td key={`units-price-${index}`} className="text-right">
        {formatCurrencyDecimals(data.unitsPrice)}
      </td>
      <td key={`result-price-${index}`} className="text-right">
        {formatCurrencyDecimals(resultPrice)}
        <sup>&nbsp;</sup>
      </td>
    </>
  );
};

export default PlanTableRow;
